// src/api/voucherGameApi.js
// Admin APIs for Printed Voucher Game (batch -> import codes -> prizes/rules -> redemptions)
//
// Base URL: REACT_APP_API_BASE_URL (vd https://localhost:7212/api)
// If backend has prefix (vd /api/v1), set PREFIX = "/api/v1"

import axios from "axios";
import config from "../config";

const PREFIX = "/v1"; // change if needed, e.g. "/api/v1"

const api = axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 20000,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const p = (path) => `${PREFIX}${path}`;

// -------- Batches --------
export const vgListBatches = async ({ page = 1, pageSize = 50 } = {}) => {
  const res = await api.get(p("/admin/printed-vouchers/batches"), {
    params: { page, pageSize },
  });
  return res.data; // { items, page, pageSize, total } hoặc tuỳ backend
};

export const vgCreateBatch = async (payload) => {
  const res = await api.post(p("/admin/printed-vouchers/batches"), payload);
  return res.data;
};

// -------- Import codes --------
export const vgImportCodes = async (payload) => {
  // payload: { batchId, codesText, expiresAt, notes }
  const res = await api.post(p("/admin/printed-vouchers/import"), payload);
  return res.data; // { inserted, duplicated }
};

// -------- Printed vouchers --------
export const vgListVouchers = async ({
  batchId,
  status,
  code,
  page = 1,
  pageSize = 50,
} = {}) => {
  const res = await api.get(p("/admin/printed-vouchers"), {
    params: { batchId, status, code, page, pageSize },
  });
  return res.data; // { items, page, pageSize, total }
};

export const vgUpdateVoucherStatus = async (code, payload) => {
  // payload: { status: "PACKED"|"SHIPPED"|"VOID" }
  const res = await api.patch(p(`/admin/printed-vouchers/${encodeURIComponent(code)}/status`), payload);
  return res.data;
};

// -------- Prizes --------
export const vgListPrizes = async ({ active } = {}) => {
  const res = await api.get(p("/admin/prizes"), { params: { active } });
  return res.data; // array hoặc { items... } tuỳ backend
};

export const vgCreatePrize = async (payload) => {
  const res = await api.post(p("/admin/prizes"), payload);
  return res.data;
};

// -------- Prize rules --------
export const vgGetRules = async (batchId, experience) => {
  const res = await api.get(p(`/admin/batches/${batchId}/prize-rules`), {
    params: { experience },
  });
  return res.data; // list rules
};

export const vgUpsertRules = async (batchId, payload) => {
  // payload: { experience: "SPIN"|"GIFTBOX", rules: [{prizeId,weight,dailyLimit,totalLimit,isActive}] }
  const res = await api.post(p(`/admin/batches/${batchId}/prize-rules`), payload);
  return res.data;
};

// -------- Redemptions --------
export const vgListRedemptions = async ({
  batchId,
  status,
  page = 1,
  pageSize = 50,
} = {}) => {
  const res = await api.get(p("/admin/redemptions"), {
    params: { batchId, status, page, pageSize },
  });
  return res.data; // { items, page, pageSize, total }
};
